

import React, { useState } from "react"
import { TextField, IconButton, InputAdornment } from "@material-ui/core"
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

export const PasswordInput = (props) => {

    const [showPassword, setShowPassword] = useState(false)

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
      };
    
    const handleMouseDownPassword = event => {
        event.preventDefault();
    };

    return (<TextField type={showPassword ? 'text' : 'password'} InputProps={{
                    endAdornment: <InputAdornment position="start"><IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}>
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                </InputAdornment>}} {...props} />)
}